import React, { Component } from 'react';
import { Table, Modal, Button, Input, Tabs, message } from 'antd';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

const TabPane = Tabs.TabPane;
const { TextArea } = Input;

class ApprovalHistory extends Component {
    state = {
        data: [],
        record: {},
        visible: false,
        loading: false,
    }

    show = (record) => {
        this.setState({
            record,
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            data: [],
            visible: false,
        });
    }

    loadData = () => {
        const { record: { jdeApplyId } } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.contract.queryJdeApplyApprovalHistory,
            data: {
                jdeApplyId,
                type: 'JDE_APPLY_LOG',
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    data: res.data,
                    loading: false,
                })
            }
        };
        $.sendRequest(options);
    }

    getColumns = () => ([
        {
            title: '操作时间',
            dataIndex: 'approvalDateShow',
            width: 80,
        }, {
            title: '操作人',
            dataIndex: 'userCompellation',
            width: 100,
            render: (text, record) => {
                const { employeeCode } = record;
                return `${text || ''}${employeeCode ? `(${employeeCode})` : ''}`;
            }
        }, {
            title: '操作内容',
            dataIndex: 'approvalContent',
            width: 110,
        }, {
            title: '操作结果',
            dataIndex: 'approvalResult',
            width: 110,
        },  {
            title: '拒绝/不通过原因',
            dataIndex: 'comments',
            width: 140,
        }
    ])

    getDataSource = () => {
        const { data } = this.state;
        const dataSource = data.map(item => ({ ...item } ));
        return dataSource;
    }

    render() {
        const { visible, loading, record: { jdeApplyCode } } = this.state;
        return (
            <Modal
                title="操作日志"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width={800}
                bodyStyle={{ maxHeight: 600 }}
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <div className="cont-cont contract-record" style={{margin: 20}}>
                    <div style={{ marginBottom: 16 }}>
                        申请编号：{jdeApplyCode}
                    </div>
                    <div style={{ marginTop: -1, borderBottom: '1px solid #e9e9e9' }}>
                        <Table
                            bordered
                            loading={loading}
                            pagination={false}
                            scroll={{x: 540, y: 400}}
                            columns={this.getColumns()}
                            dataSource={this.getDataSource()}
                            rowKey={record => record.jdeApplyApprovalHistoryId}
                        />
                    </div>
                </div>
            </Modal>
        );
    }
}

class ContractAttachment extends Component {
    state = {
        data: [],
        record: {},
        visible: false,
        activeKey: 'advance',
    }
    
    show = record => {
        this.setState({
            record,
            visible: true
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            data: [],
            visible: false,
            activeKey: 'advance',
        });
    }

    handleTabsChange = (activeKey) => {
        this.setState({
            data: [],
            activeKey,
        }, () => {
            const { record: { investigationId, natureOfContract } } = this.state;
            if (activeKey === 'contarct' && (natureOfContract === 'TERMINATION_CONTRACT' || natureOfContract === 'TERMINATION_LETTER')) {
                this.queryInvFinishInfo(investigationId, () => this.loadData());
            } else {
                this.loadData();
            }
        });
    }

    queryInvFinishInfo = (investigationId, callback) => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.proContract.getInvTerminationApplyInfo,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data: { fileList } } = res;
                this.setState({
                    data: fileList,
                    loading: false,
                }, () => {
                    callback && callback();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    loadData = () => {
        const { activeKey, record: { jdeApplyId } } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'post',
            url: API_URL.contract.queryJdeApplyFileMetaById,
            data: {
                jdeApplyId,
                uploadType: activeKey == 'advance' ? 'ADVANCE_WORK' : activeKey =='close' ? 'CLOSE': 'CONTRACT',
            },
            dataType: 'json',
            doneResult: res => {
                const { data } = this.state;
                this.setState({
                    loading: false,
                    data: data.concat(res.data),
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    downLoadFile = (e, id) => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({fileMetaId: id}, null, url);
    }

    getColumns = () => [{
        title: '序号',
        dataIndex: 'index',
        key: 'index',
        width: 85,
    }, {
        title: '附件名称',
        dataIndex: 'name',
        key: 'name',
        width: 335,
        render: (text, record) => (
            <a onClick={e => this.downLoadFile(e, record.fileMateId)}>{text}</a>
        )
    }]

    getDateSource = () => {
        const { data = [] } = this.state;
        const dataSource = [];

        data.map((item, index) => {
            dataSource.push({
                index: index + 1,
                ...item,
            })
        });

        return dataSource;
    }

    getContent = () => {
        const { loading } = this.state;
        return (
            <div>
                <Table
                    columns={this.getColumns()}
                    dataSource={this.getDateSource()}
                    rowKey={record => record.index}
                    scroll={{x: 420}}
                    pagination={false}
                    loading={loading}
                />
                <div style={{ position: 'relative', top: -1, borderTop: '1px solid #e4e4e4' }} />
            </div>
        );
    }

    render () {
        const { visible, activeKey, record: { jdeApplyCode } } = this.state;
        return (
            <Modal
                title="查看附件"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width="480px"
                footer={<Button type="primary" onClick={this.hide}>关 闭</Button>}
            >
                <div className="cont-cont contract-record" style={{margin: 20}}>
                    <div style={{ marginBottom: 16 }}>
                        申请编号：{jdeApplyCode}
                    </div>
                    <Tabs activeKey={activeKey} onChange={this.handleTabsChange} type="card">
                        <TabPane tab="提前上岗授权函" key="advance">{this.getContent()}</TabPane>
                        <TabPane tab="关闭凭证" key="close">{this.getContent()}</TabPane>
                        <TabPane tab="合同附件" key="contarct">{this.getContent()}</TabPane>
                    </Tabs>
                </div>
            </Modal>
        );
    }
}

class RejectCreateProject extends Component {
    state = {
        record: {},
        params: {},
        visible: false,
        loading: false,
    }

    show = (record) => {
        this.setState({
            record,
            params: {},
            visible: true,
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    handleNumberChange = (e, key) => {
        const { params } = this.state;
        params[key] = e.target.value;
        this.setState({ params });
    }

    submit = () => {
        const { params: { comments }, record: { jdeApplyId } } = this.state;
        if (!comments) {
            message.warning('请填写拒绝原因');
            return;
        }
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.contract.ctaRefusedJdeApply,
            data: {
                comments,
                jdeApplyId,
            },
            dataType: 'json',
            doneResult: () => {
                this.setState({
                    loading: false,
                }, () => {
                    this.hide();
                    this.props.loadData();
                })
            }
        };
        $.sendRequest(options);
    }

    render() {
        const { visible, loading, params: { comments } } = this.state;
        const asterisk = <span style={{color: 'red'}}>*</span>;
        return (
            <Modal
                title="拒绝创建项目"
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="480px"
            >
                <div className="modal-content contract-record" style={{margin: 20}}>
                    <ul className="modal-list">
                        <li className="modal-item">
                            <div className="item-left">{asterisk}请填写拒绝原因：</div>
                            <div className="item-right">
                                <TextArea
                                    rows={4}
                                    value={comments}
                                    placeholder="请填写"
                                    onChange={e => this.handleNumberChange(e, 'comments')}
                                />
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        );
    }
}

export { ApprovalHistory, ContractAttachment, RejectCreateProject };



// WEBPACK FOOTER //
// ./src/components/contractManagement/ApplyJdeCode/PreviewModal.js